import ToastCustom from 'src/javascripts/components/alerts/ToastCustom';
import Spinner from 'src/javascripts/components/utilities/Spinner';
import {filterTypeahead} from 'src/javascripts/components/typeaheads/TypeaheadBloodhounds';
import {noResultsTemplate, logoTemplate} from 'src/javascripts/components/typeaheads/TypeaheadTemplates';
import 'summernote/dist/summernote-bs4.min.js'

export default class ClientsHouseholdsEdit {

  constructor() {}

  render() {
    const accountUrl = $('body').attr('data-account-url');

    // Filter typeaheads
    filterTypeahead('#search_clients', 'clients', '/' + accountUrl + '/clients?', 132, 'generic');

    // Add portfolio and issuer ids to params for reload
    let reloadParams = function() {
      let params = {};
      params['client_ids'] = $('#client_ids').val();
      if (params['client_ids'] === '') {
        params['client_ids'] = [];
      } else if (typeof params['client_ids'] === 'string') {
        params['client_ids'] = JSON.parse(params['client_ids']);
      }
      let householdName = $('#client_household_name').val();
      if (typeof householdName !== 'undefined') {params['name'] = householdName}
      return params;
    }

    // On selecting a client
    $('#search_clients').bind('typeahead:select typeahead:autocomplete', function(ev, suggestion) {
      $(this).typeahead('val','');
      $(this).blur();
      $('.modal-body').css('opacity', 0.2);
      Spinner($('.modal-content'));

      // Add by params
      let url = window.location.href.split('?')[0];
      let params = reloadParams();

      params['client_ids'].push(suggestion.record_id);
      Turbo.visit(url + '?' + $.param(params));

    });

    // Remove client
    $('.remove-client-from-household').off().click(function() {
      let row = $(this).closest('.household-client-row');
      row.remove();

      // Reload
      let url = window.location.href.split('?')[0];
      let params = reloadParams();
      let cid = $(this).attr('data-client-id');

      // Remove the client ID from the array
      const index = params['client_ids'].indexOf(parseInt(cid));
      if (index > -1) {
        params['client_ids'].splice(index, 1);
      }

      // Reload the page
      Turbo.visit(url + '?' + $.param(params));
      
    });


  }
}